<template>
    <div>
        <table class="table table-striped">
            <caption v-if="caption">{{ caption }}</caption>
            <thead v-if="option('header', true)">
                <tr>
                    <th v-for="(c,i) in colDefs" :key="i">
                        {{ c.name }}
                    </th>
                    <th class="controls"></th>
                </tr>
            </thead>
            <tbody >
                <tr v-for="(r,i) in value" :key="i">
                    <td v-for="(c,k) in colDefs" :key="k" :class="{'empty': r[k] === undefined}">
                        <template v-if="c.type === 'select'">
                            {{ c.options[r[k]] }} 
                        </template>
                        <template v-else>
                            {{ r[k] }}
                        </template>
                    </td>
                    <td class="controls">
                        <button class="btn btn-danger" @click="removeItem(i)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td v-for="(c,i) in colDefs" :key="i">
                        <span class="input-with-errors">
                            <input v-if="c.type === 'checkbox'" type="checkbox" v-model="newItem[i]">
                            <select v-else-if="c.type === 'select'" v-model="newItem[i]">
                                <option v-for="(v,k) in c.options" :key="k" :value="k">{{ v }}</option>
                            </select>
                            <input v-else v-validate :name="i" type="text" v-model="newItem[i]" :pattern="c.pattern" :required="c.required" />
                            <ul>
                                <li v-for="e in errors.collect(i)" :key="e">{{ e }}</li>
                            </ul>
                        </span>
                    </td>
                    <td class="controls">
                        <button class="btn btn-primary" @click="addItem" :disabled="!addItemEnabled">
                            <i class="fas fa-plus"></i>
                        </button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import _ from 'lodash'

const DEFAULT_OPTIONS = {
    header: true,
}

const defaultValueFromCol = c => _.get(c, 'defaultValue', undefined)

export default {
    name: 'Grid',
    props: {
        value: {
            type: Array,
            required: false,
            default: _ => [],
        },
        cols: {
            type: Object,
            required: false,
            default: _ => { return {} },
        },
        caption: {
            type: String,
            required: false,
        },
        options: {
            type: Object,
            required: false,
            default: _ => DEFAULT_OPTIONS,
        },
    },
    data() {
        return {
            newItem: {}
        }
    },
    mounted() {
        this.newItem = _.mapValues(this.cols, defaultValueFromCol)
    },
    computed: {
        colDefs() {
            return _.mapValues(this.cols, (c,k) => _.defaultsDeep(c, {
                name: k,
                type: String,
                pattern: false,
            }))
        },
        addItemEnabled() {
            return this.errors.all().length === 0 && _.size(this.newItem) > 0
        },
    },
    methods: {
        addItem() {
            this.$emit('input', [...this.value, this.newItem])
            this.newItem = _.mapValues(this.cols, defaultValueFromCol)
        },
        removeItem(index) {
            this.$emit('input', _.remove(this.value, (_,i) => i !== index))
        },
        option(path, defaultValue = undefined) {
            return _.get(this.options, path, _.get(DEFAULT_OPTIONS, path, defaultValue))
        },
    }
}
</script>

<style scoped>
.empty {
    height: 1em;
    background: repeating-linear-gradient(
        135deg,
        transparent 0,
        transparent 7px,
        rgba(0,0,0,0.03) 7px,
        rgba(0,0,0,0.03) 14px
    );
}
.controls {
    width: 20px;
}
textarea, select, input, button { outline: none; border: 1px solid black }
input:invalid {
    border-color: var(--danger);
}
input:valid {
    border-color: var(--success);
}
.input-with-errors {
    display: flex;
    flex-direction: column;
}
.input-with-errors ul {
    margin: 5px auto 0 30px;
}
.input-with-errors li {
    color: var(--danger);
    font-style: italic;
    list-style: square;
}
caption {
  caption-side: top;
  font-weight: bold;
  color: var(--danger)
}
</style>
